export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/Clock.df672ba8.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};